export default __webpack_public_path__ + "static/ReportSample-05572bc0d16e0d296548c6ae52015f16.png";